import { render, staticRenderFns } from "./markaObmen.vue?vue&type=template&id=10a288ae&scoped=true&"
import script from "./markaObmen.vue?vue&type=script&lang=js&"
export * from "./markaObmen.vue?vue&type=script&lang=js&"
import style0 from "./markaObmen.vue?vue&type=style&index=0&id=10a288ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a288ae",
  null
  
)

export default component.exports